<template>
  <div class="pageWrapper bg-color-secondary">
    <div class="faqs">
      <HelpTopics :hiddenCategories="[isWebsiteLevel2 ? 'Video guides': '']"/>
    </div>
  </div>
</template>

<script>
import HelpTopics from '@/components/newHomepage/HelpTopics.vue';

export default {
    name: 'faqs',
    components: { HelpTopics },

    computed: {
        isWebsiteLevel2 () {
            return this.websiteLevel === 2;
        },
        websiteLevel () {
            return this.clientConfig.websiteLevel;
        },
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
    },
    metaInfo () {
        return {
            title: 'Frequently asked questions',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Frequently asked questions',
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';
.bg-color-secondary {
  background-color: $sectionColor1;
}

.faqs {
  min-height: 80vh;
  padding: 40px 0 80px 0;
}
</style>
